import React, { Component } from 'react'
import columns from './columns'
import store from '../store'
import Table from '@common/Table'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { detail } = store
    return (
      <Table
        store={store}
        columns={columns(detail.created_at)}
        shouldGetListWhenDidMount={false}
      />
    )
  }
}
